module.exports = __webpack_public_path__ + "static/media/destaque-linhas-facial.dc5f73b6.jpg";